const BBS_FAVOURITES_KEY = 'bbs-favourites';

class BBSFavourites {
  static getAll() {
    try {
      return JSON.parse(localStorage.getItem(BBS_FAVOURITES_KEY) || '[]');
    } catch {
      return [];
    }
  }

  static save(ids) {
    localStorage.setItem(BBS_FAVOURITES_KEY, JSON.stringify(ids));
  }

  static toggle(productId) {
    const ids = BBSFavourites.getAll();
    const id = String(productId);
    const index = ids.indexOf(id);
    if (index === -1) {
      ids.push(id);
    } else {
      ids.splice(index, 1);
    }
    BBSFavourites.save(ids);
    return ids.includes(id);
  }

  static isFavourite(productId) {
    return BBSFavourites.getAll().includes(String(productId));
  }

  static applyToPage() {
    document.querySelectorAll('[data-bbs-favourite]').forEach((btn) => {
      const id = btn.dataset.bbsFavourite;
      const active = BBSFavourites.isFavourite(id);
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      const icon = btn.querySelector('.material-symbols-outlined');
      if (icon) {
        icon.style.fontVariationSettings = active ? "'FILL' 1" : "'FILL' 0.2";
      }
    });
  }

  static filterGrid(showOnlyFavourites) {
    const favourites = BBSFavourites.getAll();
    document.querySelectorAll('[data-bbs-grid-item]').forEach((item) => {
      const id = item.dataset.productId;
      const isFav = favourites.includes(String(id));
      if (showOnlyFavourites && !isFav) {
        item.classList.add('is-hidden');
      } else {
        item.classList.remove('is-hidden');
      }
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  BBSFavourites.applyToPage();

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-bbs-favourite]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    const active = BBSFavourites.toggle(btn.dataset.bbsFavourite);
    btn.classList.toggle('is-active', active);
    btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    const icon = btn.querySelector('.material-symbols-outlined');
    if (icon) {
      icon.style.fontVariationSettings = active ? "'FILL' 1" : "'FILL' 0.2";
    }
    const favToggle = document.querySelector('[data-bbs-favourites-toggle]');
    if (favToggle?.checked) {
      BBSFavourites.filterGrid(true);
    }
  });

  const favToggle = document.querySelector('[data-bbs-favourites-toggle]');
  if (favToggle) {
    favToggle.addEventListener('change', () => {
      BBSFavourites.filterGrid(favToggle.checked);
    });
  }
});

window.BBSFavourites = BBSFavourites;
